import { BuildingOfficeIcon } from "@heroicons/react/24/outline";
import { ReferralTypesOptions } from "@sp-crm/core";
import { Checkbox } from "components/ui/checkbox";
import { defaultLinkStyle } from "components/ui/link";
import React, { useMemo } from "react";

export const OrganizationTypeIcon: React.FC = () => (
    <BuildingOfficeIcon className="w-5 h-5 flex-shrink-0 mr-2" />
);

interface ClearAllLinkProps {
    onClear: () => void;
}

export const ClearAllLink: React.FC<ClearAllLinkProps> = ({ onClear }) => (
    <a
        href="#"
        className={`${defaultLinkStyle} block`}
        onClick={e => {
            e.preventDefault();
            onClear();
        }}>
        Clear all
    </a>
);

type ReferralTypeGroup = (typeof ReferralTypesOptions)[number];

const referralTypeGroupsMatching = (filterText: string): ReferralTypeGroup[] => {
    const needle = filterText.toLowerCase();
    return ReferralTypesOptions.map(group => ({
        header: group.header,
        groupOptions: group.groupOptions.filter(
            option =>
                group.header.toLowerCase().includes(needle) ||
                option.text.toLowerCase().includes(needle),
        ),
    })).filter(group => group.groupOptions.length > 0);
};

interface ReferralTypeChecklistGroupsProps {
    filterText: string;
    value: string[];
    onCheck: (orgType: string) => void;
    onUncheck: (orgType: string) => void;
}

export const ReferralTypeChecklistGroups: React.FC<ReferralTypeChecklistGroupsProps> = ({
    filterText,
    value,
    onCheck,
    onUncheck,
}) => {
    const groups = useMemo(() => referralTypeGroupsMatching(filterText), [filterText]);
    return (
        <>
            {groups.map(group => (
                <li key={group.header}>
                    <p className="font-bold">{group.header}</p>
                    <ul>
                        {group.groupOptions.map(option => (
                            <li key={option.value}>
                                <Checkbox
                                    checked={value.includes(option.value)}
                                    onChange={e =>
                                        e.target.checked
                                            ? onCheck(option.value)
                                            : onUncheck(option.value)
                                    }
                                    label={option.text}
                                />
                            </li>
                        ))}
                    </ul>
                </li>
            ))}
        </>
    );
};
